import { hotelRoomSchema, hotelSchema } from 'store/schemas/database.schema';
import { normalize } from 'normalizr';
import { putDatabase } from 'store/actions/database.actions';
import { actionCreators } from '../actions/metaDatabase.hotels.actions';
import HotelsRepository from '../../services/repositories/HotelsRepository';
import {
    buildMetaHotelSelector,
    buildMetaHotelsFeaturedSelector,
    buildMetaHotelsLatestSelector,
} from '../selectors/hotels.selector';
import { loadEntityBySlug, loadEntityHotelsFeatured, loadEntityHotelsLatest } from './helpers';

export function loadHotelBySlug(slug, includes = null, repository = null)
{
    let finalRepository = repository;

    if (!finalRepository) finalRepository = new HotelsRepository();

    return loadEntityBySlug(slug, includes, buildMetaHotelSelector, actionCreators, finalRepository, hotelSchema);
}

export function loadHotelRoomsBySlug(slug, includes = null)
{
    const repository = new HotelsRepository();

    return async (dispatch, getState) =>
    {
        const r = await repository.getHotelRoomsBySlug(slug);

        if (!r.isSuccess()) return r; // eslint-disable-line consistent-return

        const n = normalize(r.getData(), [hotelRoomSchema]);

        dispatch(putDatabase(n.entities));

        return r; // eslint-disable-line consistent-return
    };
}

export function loadHotelsFeatured(repository = null)
{
    let finalRepository = repository;

    if (!finalRepository) finalRepository = new HotelsRepository();

    return loadEntityHotelsFeatured(buildMetaHotelsFeaturedSelector, actionCreators, finalRepository, hotelSchema);
}

export function loadHotelsLatest(repository = null)
{
    let finalRepository = repository;

    if (!finalRepository) finalRepository = new HotelsRepository();

    return loadEntityHotelsLatest(buildMetaHotelsLatestSelector, actionCreators, finalRepository, hotelSchema);
}
